/**
 * Legacy SubscriptionsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.subscriptionsApi`) keep resolving.
 *
 * The actual SubscriptionsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/subscriptions/subscriptions-api.service.ts
 */
angular.module("acme.common.service.subscriptionsApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
